import { TranslatorService } from './../../../core/services/translator/translator.service';
import { Component, OnInit, ViewChild } from '@angular/core';

import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatHorizontalStepper, MatStepper } from '@angular/material/stepper';
import { MasterHomeCreateProfileService } from './service/master-home-create-profile.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MasterCreateProfileService } from './views/permissoes/master-create-profile.service';
import { MasterUsersProfileService } from './views/usuarios/master-create-profile-users.service';

import { DialogBoxService } from '../../../custom-shared/components/alerts/dialog-box-service';
import { FeatureService } from '@app/core/services/feature/feature.service';
import { MasterCreateProfileComponent } from './views/permissoes/master-create-profile.component';

enum messages {
  usersNotChoiced = 'É necessário escolher um usuário',
  nameProfileNotSet = 'É necessário escolher um nome para o perfil',
  permissionsNoSelected = 'É necessário escolher pelo menos uma permissão',
}

@Component({
  selector: 'app-master-home-create-profile',
  templateUrl: './master-home-create-profile.component.html',
  styleUrls: ['./master-home-create-profile.component.scss'],
  providers: [
    MasterHomeCreateProfileService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class MasterHomCreateProfileComponent implements OnInit {
  constructor(
    private serviceHomeCreateProfile: MasterHomeCreateProfileService,
    private serviceCreateProfile: MasterCreateProfileService,
    private serviceUserProfileEdit: MasterUsersProfileService,
    public dialogRef: MatDialogRef<MasterHomCreateProfileComponent>,
    private snackBarService: DialogBoxService,
    private featureService: FeatureService,
    private translatorService : TranslatorService,
  ) { }

  usersSelected: Array<string>;
  rolesSelected: Array<string>;
  permissions: any = [];
  userseToOveridePermissions: any = [];
  usersToconfirm: any;
  firstFormGroup: false;
  nextStep: boolean = true;
  
  @ViewChild(MasterCreateProfileComponent) masterCreateProfileComponent!: MasterCreateProfileComponent;

  @ViewChild('stepper', { static: false }) stepper: MatHorizontalStepper;
  ngOnInit() {
    MasterHomeCreateProfileService.emitirListProfiles.subscribe(v => {
      this.permissions = this.serviceHomeCreateProfile.dataPermissions();
    });
  }

  confirmDuplicatedProfileDialog(profilesExists) {
    let title,cancel,duplicate:string
    title =  this.translatorService.translateConfirmBox('titleCreateProfile')
    cancel =  this.translatorService.translateConfirmBox('cancelConfirm')
    duplicate =  this.translatorService.translateConfirmBox('okDuplicate')

    return this.snackBarService.confirmBox({
      lblTitle: title,
      lblSubtitle: this.treatmentListOfProfiles(profilesExists),
      lblCancelButton: cancel,
      lblConfirmButton: duplicate,
      color: 'red',
      onConfirm: async () => {
        const profileCreateResponse = await this.createProfile(true);

        const { id } = profileCreateResponse;

        const users = await this.serviceHomeCreateProfile.dataToAssociateUsers(
          id,
        );

        if (users.length > 0) {
          const editUsers = await this.serviceUserProfileEdit.editUserProfile(
            users,
          );
          const { rejectedUsers }: any = editUsers;
          if (rejectedUsers.length > 0) {
            await this.confirmOverridePermisssion(editUsers, id);
            return;
          }
        }

        this.dialogRef.close();
      },
    });
  }

  doFechar() {
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('titleConfirm')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('subtitleConfirm')
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okConfirm')
      .subscribe(val => {
        okpopup = val
      })

    this.snackBarService.confirmBox({
      lblTitle: titlepopup,
      lblSubtitle: subtitlepopup,
      lblCancelButton: cancelpopup,
      lblConfirmButton: okpopup,
      color: ' red',
      onConfirm: () => {
        this.dialogRef.close();
      },
    });
  }

  translatePermissionNotSelected():string{
    let  permissionsNoSelectedMsg =  this.featureService.translatorService
    .translateEnumItem(
      messages.permissionsNoSelected,
      'messages'
    )
    return permissionsNoSelectedMsg;
  }
  async validateNamePermission() {
    const { permissions } = this.permissions;

    const { name } = this.serviceHomeCreateProfile.form.value;
    let  nameProfileNotSetMsg =  this.featureService.translatorService
    .translateEnumItem(
      messages.nameProfileNotSet,
      'messages'
    )
    if (!name) {
      this.snackBarService.snackbarUtil.showError(nameProfileNotSetMsg);
      return;
    }
    let permissionMsg=this.translatePermissionNotSelected();
    if (permissions.length == 0) {
      this.snackBarService.snackbarUtil.showWarn(
        permissionMsg,
      );

      return;
    }

    try {
      const payload = { name: name };
      const checNamePermission = await this.serviceCreateProfile.checkPermissionName(payload);

      const { exists: namePermissionExists } = checNamePermission;
      let profileNameDuplicatedStart,profileNameDuplicatedEnd:string;
      this.translatorService.getMessage('ProfileNameDuplicatedStart').subscribe(
        data=>profileNameDuplicatedStart=data
      )
      this.translatorService.getMessage('ProfileNameDuplicatedEnd').subscribe(
        data=>profileNameDuplicatedEnd=data
      )
      if (namePermissionExists) {
        this.snackBarService.snackbarUtil.showWarn(
          profileNameDuplicatedStart+` ${name} `+profileNameDuplicatedEnd,
        );
        return;
      }

      const {
        exists: existsProfile,
        profiles: profilesExists,
        id,
      } = await this.createProfile(false);

      if (existsProfile) {
        this.confirmDuplicatedProfileDialog(profilesExists);
        return;
      }
      let profileCreatedMsg:string;
      this.translatorService.getMessage('profileCreated').subscribe(
        data=>profileCreatedMsg=data
      )
      const users = await this.serviceHomeCreateProfile.dataToAssociateUsers(
        id,
      );

      if (users.length > 0) {
        const editUsers = await this.serviceUserProfileEdit.editUserProfile(
          users,
        );

        const { rejectedUsers }: any = editUsers;
        if (rejectedUsers.length > 0) {
          await this.confirmOverridePermisssion(editUsers, id);
          return;
        }
      }

      if (id) {
        this.dialogRef.close();
        profileCreatedMsg.showSuccess();
        return;
      }
    } catch (error) {
      return error;
    }
  }

  async validatePermissionsExists() {
    try {
      await this.serviceCreateProfile.checkPermissionExists();
    } catch (error) {
      return error;
    }
  }

  async createProfile(force = false) {
    try {
      const {
        name: profile,
        description,
      } = this.serviceHomeCreateProfile.form.value;
      return await this.serviceCreateProfile.createProfile({
        profile,
        description,
        ...this.permissions,
        forceTrue: force,
      });
    } catch (error) {
      return error;
    }
  }

  async confirmOverridePermisssion(editUsersResponse, newId) {
    const { rejectedUsers } = editUsersResponse;
    this.usersToconfirm = rejectedUsers.map(user => ({
      name: user.name,
      profile: {
        name: user.profile.name,
      },
    }));

    this.userseToOveridePermissions = await rejectedUsers.map(user => ({
      user_id: user.user_id,
      profile: {
        id: newId,
      },
    }));
  }

  async overridPermissions() {
    await this.serviceUserProfileEdit.confirmOverrideProfile(
      this.userseToOveridePermissions,
    );

    this.dialogRef.close();
  }

  async checkNameProfile(stepper: MatStepper) {
    let warnPerm : string
    stepper.previous();
    const { name } = this.serviceHomeCreateProfile.form.value;
    let  nameProfileNotSetMsg =  this.featureService.translatorService
    .translateEnumItem(
      messages.nameProfileNotSet,
      'messages'
    )
    this.featureService.translatorService.
    getMessage('Selecione ao menos 1 relatório')
    .subscribe(
      data=>warnPerm=data
    )
    const isValid = this.masterCreateProfileComponent.validateCheckedItems();
    if (!isValid) {
      warnPerm.showWarn();
      return;
    }
    if ((!name) || (name.trim().length === 0)) {
      this.snackBarService.snackbarUtil.showWarn(nameProfileNotSetMsg);
      stepper.previous();
      return;
    }
    const payload = { name: name };
    const checNamePermission = await this.serviceCreateProfile.checkPermissionName(payload);

    const { exists } = checNamePermission;
    const { permissions } = this.permissions;
    let permissionMsg=this.translatePermissionNotSelected()
    if (permissions.length === 0) {
      this.snackBarService.snackbarUtil.showWarn(
        permissionMsg,
      );
      stepper.previous();
      return;
    }
    let profileNameDuplicatedStart,profileNameDuplicatedEnd:string;
    this.translatorService.getMessage('ProfileNameDuplicatedStart').subscribe(
      data=>profileNameDuplicatedStart=data
    )
    this.translatorService.getMessage('ProfileNameDuplicatedEnd').subscribe(
      data=>profileNameDuplicatedEnd=data
    )
    if (exists) {
      this.snackBarService.snackbarUtil.showWarn(
        profileNameDuplicatedStart+` ${name} `+profileNameDuplicatedEnd,
      );
      stepper.previous();
      return;
    }
    stepper.next();
  }

  treatmentListOfProfiles(profiles: Array<{ id: string; name: string }>) {
    let msg1,msg2,msg3:string 
    msg1 = this.translatorService.translateConfirmBox('mesageCreateProfile1')
    msg2 = this.translatorService.translateConfirmBox('mesageCreateProfile2')
    msg3 = this.translatorService.translateConfirmBox('mesageCreateProfile3')

    if (profiles.length > 1) {
      return msg1+` (${profiles
        .map(a => `${a.name}`)
        .join(
          ', ',
        )}`+ msg2;
    }

    return msg3+` (${profiles
      .map(a => `${a.name}`)
      .join(
        ', ',
      )}`+msg2;
  }

  submit() {
    this.validateNamePermission();
  }
}
